export default class LogServiceMock {
  public async init(componentName = ''): Promise<any> {
    return {}
  }

  async log(log: any, type: string) {
    return {}
  }

  shouldLog() {
    return {}
  }

  async info(message: { message: string; user?: any; request?: any }) {
    return {}
  }

  async error(message: { message: string; user?: any; request?: any; error?: any }) {
    return {}
  }

  async warn(message: { message: string; user?: any; request?: any }) {
    return {}
  }
}
